import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  importFileModalSetUploadedFileReducerType,
  importFileModalSetIsLoadingReducerType,
  importFileModalSetIsClosedReducerType,
} from './ImportFileModalConstants';

export const initialState = Map({
  isLoading: false,
  isClosed: false,
  uploadedFile: null,
});

const spec = {
  [importFileModalSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [importFileModalSetIsClosedReducerType]: (state, action) => {
    const { isClosed } = action.payload;
    return state.set('isClosed', isClosed);
  },
  [importFileModalSetUploadedFileReducerType]: (state, action) => {
    const { uploadedFile } = action.payload;
    return state.set('uploadedFile', uploadedFile);
  },
};

export default createReducerBySpec(spec, initialState);
